import manifest from '../data/portfolioManifest.json';

// Standardvärden för hur en bild passas in i sin container.
export const DEFAULT_FIT = 'cover';
export const DEFAULT_FOCUS_X = 50;
export const DEFAULT_FOCUS_Y = 50;

const withFit = (obj) => ({
  fit: DEFAULT_FIT,
  focusX: DEFAULT_FOCUS_X,
  focusY: DEFAULT_FOCUS_Y,
  ...obj,
});

// { slot: { basePath, filename, alt, fit, focusX, focusY } }
export const buildFallbackSiteImages = () => {
  const out = {};
  for (const [slot, def] of Object.entries(manifest.siteImages)) {
    out[slot] = withFit({ basePath: def.basePath, filename: def.file, alt: def.alt });
  }
  return out;
};

export const fallbackSiteImage = (slot) => {
  const def = manifest.siteImages[slot];
  if (!def) return null;
  return withFit({ basePath: def.basePath, filename: def.file, alt: def.alt });
};

// Kategori (tjänstesida) → { title, description, sectionTitle, projects: [{ title, cover, images }] }
export const buildFallbackCategory = (category) => {
  const cat = manifest.categories[category];
  if (!cat) return null;
  const projects = cat.projects.map((p, pi) => {
    const basePath = p.basePath || cat.basePath;
    const images = p.files.map((file, i) =>
      withFit({ id: `f-${category}-${pi}-${i}`, basePath, filename: file, alt: p.title })
    );
    return { title: p.title, cover: images[0], images };
  });
  return {
    title: cat.title,
    description: cat.description,
    sectionTitle: cat.sectionTitle,
    projects,
  };
};

// Startsidans galleri → [{ id, basePath, filename, alt, rows, fit, focusX, focusY }]
export const buildFallbackGallery = () =>
  manifest.gallery.map((g, i) =>
    withFit({
      id: `f-gallery-${i}`,
      basePath: g.basePath,
      filename: g.file,
      alt: g.alt,
      rows: g.tall ? 2 : 1,
    })
  );
